import "../css/style.scss"

// Our modules / classes
import MobileMenu from "./modules/MobileMenu"
import MiniCart from "./modules/MiniCart";
import ScrollHandler from "./modules/ScrollHandler";

// import WooCommerceHandler from "./modules/WooCommerceHandler";
// import HoverHandler from "./modules/HoverHandler";

// Instantiate a new object using our modules/classes
const mobileMenu = new MobileMenu()

const miniCart = new MiniCart();
const scrollHandler = new ScrollHandler();

// const wooCommerceHandler = new WooCommerceHandler();
// const hoverHandler = new HoverHandler();


